import { InfrastructureStore } from '../Infrastructure/InfrastructureStore';
import { PodChartsStore } from '../PodCharts/PodChartsStore';
import { SeqLogsStore } from '../SeqLogs/SeqLogsStore';
import { SmartVuMetadataStore } from '../SmartVuMetadata/SmartVuMetadataStore';
import { AppStore } from '../Core/AppStore';
import { AuditStore } from '../Audit/AuditStore';
import {
    CommonAppStore,
    ErrorStore,
    HttpClient,
    TasksStore,
} from 'Mri.Web.Common';
import { UserManagerSettings } from 'oidc-client';
import { AccountStore } from '../Account/AccountStore';
import {runInAction, toJS} from "mobx";
import {cloneDeep, isEqual} from "lodash";

const httpClient = new HttpClient();
const initialOidcConfig = (window as any).initialOidcConfig as UserManagerSettings;
const accountStore = new AccountStore(httpClient, initialOidcConfig);
const appStore = new AppStore();

setupStorageSync(accountStore, appStore);

httpClient.setAccessTokenStore(accountStore);
export const stores = {
    accountStore,
    appStore,
    auditStore: new AuditStore(httpClient),
    commonAppStore: new CommonAppStore(httpClient),
    errorStore: new ErrorStore(httpClient),
    infrastructureStore: new InfrastructureStore(httpClient),
    podChartsStore: new PodChartsStore(httpClient),
    seqLogsStore: new SeqLogsStore(httpClient),
    smartVuMetadataStore: new SmartVuMetadataStore(httpClient),
    tasksStore: new TasksStore(httpClient, accountStore),
};

function setupStorageSync(accountStore: AccountStore, appStore: AppStore) {
    window.addEventListener('storage', (event) => {
        // Prevents updates if it is the active tab
        if (document.hasFocus() || document.visibilityState === 'visible') {
            return;
        }

        if (event.key === 'AccountStore.AccountStorage' && event.newValue) {
            try {
                const newStorage = JSON.parse(event.newValue);
                const oldStorage = cloneDeep(toJS(accountStore.storage)); // snapshot before update

                runInAction(() => {
                    accountStore.suppressStorageSync = true;

                    const storage = accountStore.storage as any;
                    for (const key in newStorage) {
                        if (!isEqual(storage[key], newStorage[key])) {
                            storage[key] = newStorage[key];
                        }
                    }

                    queueMicrotask(() => {
                        runInAction(() => {
                            accountStore.suppressStorageSync = false;
                        });
                    });
                });
            } catch (e) {
                console.error('Failed to sync AccountStore from localStorage:', e);
            }
        }

        if (event.key === 'AppStore.AppStorage' && event.newValue) {
            try {
                const newStorage = JSON.parse(event.newValue);
                if (newStorage.version !== appStore.storage.version) {
                    console.warn('App version mismatch detected. Reloading...');
                    window.location.reload();
                }
            } catch (e) {
                console.error('Failed to sync AppStore from localStorage:', e);
            }
        }
    });
}
